<script setup lang="ts">
import type { SidebarItem } from '~/data/studentNavs'

const props = defineProps({
  item: { type: Object as PropType<SidebarItem>, required: true },
  path: { type: String, required: true }
})

const checkActive = () => props.path === props.item.link
</script>

<template>
  <NuxtLink :class="`sidebar-item ${checkActive() ? 'sidebar-item-active' : ''}`" :to="item.link">
    <div class="sidebar-item-icon"><component :is="item.icon" /></div>
    <span> {{ item.title }} </span>
  </NuxtLink>
</template>

<style scoped lang="scss">
.sidebar-item {
  $iconSize: 13px;
  display: grid;
  grid-template-columns: $iconSize 1fr;
  align-items: center;
  gap: 15px;
  height: 40px;
  padding: 0 10px;
  border-radius: 7px;

  &-icon {
    height: $iconSize;
    width: $iconSize;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      height: $iconSize;
      width: $iconSize;
      fill: var(--textM2);
    }
  }

  span {
    font-size: 0.9rem;
    color: var(--textM2);
  }
}

.sidebar-item-active {
  background-color: var(--lightPurple);

  .sidebar-item-icon {
    svg {
      fill: var(--black);
    }
  }

  span {
    color: var(--black);
  }
}

@media (hover: hover) {
  .sidebar-item:hover {
    background-color: var(--bgLight);
  }

  .sidebar-item-active:hover {
    background-color: var(--lightPurple);
  }
}
</style>
